import { h } from 'preact';
import style from './style';
import { Icon } from '@cube/blocks';
import cx from 'classnames';

/**
 * Render the Current Weather component
 * @param  {Object} The current alerts, and postal code, for this location
 * @return {String} The rendered component
 */
const WeatherAlerts = ({
	alertLevel,
	alertCount,
	alertText,
	alertURL
}) => (
	<a class={style.alertWrapper} href={alertURL} target="_blank" rel="noopener noreferrer">
		<div class={cx(style.alert, style[alertLevel])}>
			<div class={cx(style.more)}>
				<Icon name="alert-wire-cube" />
			</div>
			<div class={cx(style.message)}>
				 {alertText}  {alertCount > 1 && '('+alertCount+')'}
			</div>
		</div>
	</a>
);

export default WeatherAlerts;
